<div class="summary">
  <form [formGroup]="viewForm" class="summary__form">
    <mat-form-field class="summary__select">
      <mat-label>View Type</mat-label>
      <mat-select formControlName="viewType">
        <mat-option [value]="viewTypes.Projects">By Projects</mat-option>
        <mat-option [value]="viewTypes.Clients">By Clients</mat-option>
        <mat-option [value]="viewTypes.Users">By Users</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  
  <div class="summary__content">
    <div class="summary__table mat-elevation-z8 mat-table-responsive">
      <mat-table [dataSource]="summaries" class="summary__mat-table">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ viewForm.get('viewType')?.value === viewTypes.Projects ? 'Project' : 
               viewForm.get('viewType')?.value === viewTypes.Clients ? 'Client' : 'User' }}
          </mat-header-cell>
          <mat-cell *matCellDef="let summary">
            <span class="summary__color-dot" [style.background-color]="summary.color"></span>
            {{ summary.name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>Total</mat-footer-cell>
        </ng-container>

        <!-- Hours Column -->
        <ng-container matColumnDef="hours">
          <mat-header-cell *matHeaderCellDef>Hours</mat-header-cell>
          <mat-cell *matCellDef="let summary">
            <ng-container *ngIf="summary.hours < 0.01">{{ summary.hours * 3600 | number:'1.0-0':'en-US' }}s</ng-container>
            <ng-container *ngIf="summary.hours >= 0.01 && summary.hours < 0.1">{{ summary.hours * 60 | number:'1.0-0':'en-US' }}m</ng-container>
            <ng-container *ngIf="summary.hours >= 0.1">{{ summary.hours | number:'1.1-1':'en-US' }}h</ng-container>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>
            <ng-container *ngIf="totalHours < 0.01">{{ totalHours * 3600 | number:'1.0-0':'en-US' }}s</ng-container>
            <ng-container *ngIf="totalHours >= 0.01 && totalHours < 0.1">{{ totalHours * 60 | number:'1.0-0':'en-US' }}m</ng-container>
            <ng-container *ngIf="totalHours >= 0.1">{{ totalHours | number:'1.1-1':'en-US' }}h</ng-container>
          </mat-footer-cell>
        </ng-container>

        <!-- Percentage Column -->
        <ng-container matColumnDef="percentage">
          <mat-header-cell *matHeaderCellDef>Percentage</mat-header-cell>
          <mat-cell *matCellDef="let summary">
            {{ summary.percentage | number:'1.1-1':'en-US' }}%
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>100%</mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="['name', 'hours', 'percentage']"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['name', 'hours', 'percentage']"></mat-row>
        <mat-footer-row *matFooterRowDef="['name', 'hours', 'percentage']"></mat-footer-row>
      </mat-table>
    </div>

    <div class="summary__charts">
    <div class="summary__chart-container">
      <div class="summary__total-hours">
        Total: 
        <ng-container *ngIf="totalHours < 0.01">{{ totalHours * 3600 | number:'1.0-0':'en-US' }}s</ng-container>
        <ng-container *ngIf="totalHours >= 0.01 && totalHours < 0.1">{{ totalHours * 60 | number:'1.0-0':'en-US' }}m</ng-container>
        <ng-container *ngIf="totalHours >= 0.1">{{ totalHours | number:'1.1-1':'en-US' }}h</ng-container>
      </div>
      <div echarts [options]="chartOptions" class="summary__donut-chart"></div>
    </div>
    <div class="summary__chart-container">
      <div class="summary__total-hours">
        Detailed Time Tracks
      </div>
      <div echarts [options]="detailedChartOptions" class="donut-chart"></div>
    </div>
  </div>
</div>
